const prop = 'components';

export const config = (labels) => ({
	id: `${prop}Column`,
	label: labels[prop],
	propName: 'component',
	width: 'minmax(20rem, 4fr)',
	sortBy: 'component'
});
